import sysend from 'sysend';
import { debug } from './options/actions';
import * as ConfigurationActions from './configuration/actions';
import * as SettingsActions from './settings/actions';
import * as WidgetActions from '../components/layers/widget/actions';
import Logger from '../../common/logger';
import { WIDGET_ACTIONS, COOKIES } from '../components/layers/widget/types';
import IPC from './ipc';
import * as Conditions from '../components/layers/widget/conditions';
import { onDocumentClick } from '../components/views/chat/actions';
import * as MainActions from '../components/main/actions';
import { MAIN_ACTIONS } from '../components/main/types';
import { POPUP_ACTIONS } from '../components/layers/popup/types';

export const dispatch = (store, { command, data }) => {
    switch (command) {
        case MAIN_ACTIONS.LOAD_SETTINGS:
            SettingsActions.loadSettings(data);
            break;

        case MAIN_ACTIONS.INIT:
            MainActions.onInit();
            break;

        case MAIN_ACTIONS.LOAD_CONFIG:
            try {
                if (data.settings) {
                    SettingsActions.loadSettings(data.settings);
                }
                ConfigurationActions.loadConfig({
                    config: data.config
                });
            } catch (err) {
                Logger.error(WIDGET_ACTIONS.LOAD_CONFIG + ': ' + err.message, 'setup');
            }
            break;

        case MAIN_ACTIONS.OPEN:
            try {
                if (data.settings) {
                    SettingsActions.loadSettings(data.settings);
                }
                const events = {
                    beforeLoad: (configurationType) =>
                        MainActions.onPreloaderClose(configurationType),
                    afterLoad: () => MainActions.onOpen(data)
                };
                ConfigurationActions.loadConfig({
                    config: data.config,
                    events
                });
            } catch (err) {
                Logger.error(MAIN_ACTIONS.OPEN + ': ' + err.message, 'setup');
            }
            break;

        case POPUP_ACTIONS.OPEN:
            {
                const config = ConfigurationActions.getPopupConfig(data.configId);
                if (config && config.length > 0) {
                    MainActions.onOpen({ config: config[0] });
                }
            }
            break;

        case WIDGET_ACTIONS.CLOSE:
            WidgetActions.onClose('manual', data.force || false, data.reason || undefined);
            break;

        case WIDGET_ACTIONS.DEBUG:
            debug(data);
            break;

        case WIDGET_ACTIONS.RESIZE:
            MainActions.onParentResize({
                width: data.parentWidth,
                height: data.parentHeight
            });
            break;

        case WIDGET_ACTIONS.DOCUMENT_CLICK:
            onDocumentClick();
            break;

        case WIDGET_ACTIONS.GETSTATE:
            {
                const state = store.getState();
                const current = (
                    state && state.widget ? state.widget.currentView || '' : ''
                ).toLowerCase();
                let next;
                switch (current) {
                    case 'preloader':
                        if (Conditions.isChatAvailable(state).available) next = 'chat';
                        else next = '';
                        break;
                    case 'chat':
                        if (Conditions.isChatSaveAvailable(state).available) next = 'chatsave';
                        else if (state.questionnaire.conditionsMet) next = 'questionnaire';
                        else next = '';
                        break;
                    case 'chatsave':
                        if (state.questionnaire.conditionsMet) next = 'questionnaire';
                        else next = '';
                        break;
                    default:
                        next = '';
                        break;
                }

                IPC.sendEvent(WIDGET_ACTIONS.STATE, { current, next });
            }
            break;

        case COOKIES.CHECK_USABILA:
            WidgetActions.checkUsabilaCookie(data.isPresent);
            break;

        case WIDGET_ACTIONS.BROADCAST_ORDER_ID_TO_CHAT:
            sysend.broadcast('oplwidget', {
                source: IPC.source(),
                command: WIDGET_ACTIONS.SEND_ORDER_ID_TO_CHAT,
                data: data
            });
            WidgetActions.sendOrderIdToChat(data);
            break;

        case WIDGET_ACTIONS.SEND_ORDER_ID_TO_CHAT:
            WidgetActions.sendOrderIdToChat(data);
            break;

        case WIDGET_ACTIONS.SEND_USER_MO_LOGGED_IN_TO_CHAT:
            WidgetActions.sendUserMOLoggedInToChat();
            break;

        case WIDGET_ACTIONS.MAXIMIZE:
            WidgetActions.onMaximize();
            break;

        default:
            break;
    }
};
